import { saasModernTheme } from 'common/theme/saasModern';
import styled from 'styled-components';
import { Box, Button } from '@mui/material';

export const CardPrincing = styled(Box)`
  transition: all 0.3s ease-in-out;
  -webkit-backdrop-filter: blur(100px);
  backdrop-filter: blur(100px);
  border-radius: 24px;
  padding: ${saasModernTheme.space[6]}px;
  @media (max-width: 450px) {
    padding: ${saasModernTheme.space[5]}px;
  }
`;

export const PrincingPageHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex-wrap: wrap;
  text-align: center;
  width: 100%;
  position: relative;
  z-index: 5;
  margin-top: ${saasModernTheme.space[17]}px;
  @media (max-width: 450px) {
  }
`;

export const ContainerSwitchSubcription = styled.div`
  margin: 0 auto;
  width: 25%;
  display: flex;
  justify-content: center;
  align-items: start;
  gap: 2px;
  @media (max-width: 950px) {
    width: 40%;
  }
  @media (max-width: 450px) {
    width: 70%;
  }
`;
export const InnerContainer = styled.div`
  padding-top: 24px;
  padding-bottom: 24px;
  border-radius: 8px;
  gap: 16px;
  flex: 1;
  text-align: center;
  cursor: pointer;
  background-color: ${(props) =>
    props.active ? saasModernTheme.colors.yellow : 'transparent '};
  color: ${(props) =>
    props.active ? saasModernTheme.colors.black : saasModernTheme.colors.black};

  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 83.333% */
  @media (max-width: 450px) {
    padding-top: 16px;
    padding-bottom: 16px;
    font-size: 16px;
  }
`;

export const GridContainer = styled.div`
  display: flex;
  gap: 16px; /* Gap between grid items */
  margin: 64px auto;
  width: 95%;
  flex-wrap: wrap;
  flex-direction: row;
  @media (max-width: 450px) {
    margin-top: 36px;
    flex-direction: column;
  }
`;

export const HeaderCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const HeaderCardInfo = styled.span`
  border-radius: 4px;
  background-color: ${(props) =>
    props.active
      ? saasModernTheme.colors.yellow
      : saasModernTheme.colors.primaryLight};
  color: ${(props) =>
    props.active ? saasModernTheme.colors.black : saasModernTheme.colors.black};
  height: 28px;
  flex-shrink: 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  padding-left: 16px;
  padding-right: 16px;
`;

export const ContentPrix = styled.h3`
  color: ${(props) =>
    props.color ? props.color : saasModernTheme.colors.black};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 'bold')};
  text-transform: ${(props) =>
    props.textTransform ? props.textTransform : 'uppercase'};
  font-size: ${(props) => (props.size ? props.size : '20px')};

  font-style: normal;
  leading-trim: both;
  text-edge: cap;
`;

export const ContentPrice = styled.div`
  margin: ${saasModernTheme.space[5]}px 0;
`;

export const PriceContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Price = styled.div`
  color: ${saasModernTheme.colors.black};
  leading-trim: both;
  text-edge: cap;

  font-size: 48px;
  font-style: normal;
  font-weight: 900;
  line-height: 44px; /* 91.667% */
`;

export const PeerMonth = styled.div`
  color: ${saasModernTheme.colors.black};

  font-size: 16px;
  margin-left: 4px;
  margin-right: 4px;
`;

export const NotThePrice = styled.s`
  color: ${saasModernTheme.colors.black};
  leading-trim: both;
  text-edge: cap;

  font-size: 2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 44px; /* 91.667% */
  display: inline-block;
  margin-right: ${saasModernTheme.space[3]}px;
`;

export const LabelPrice = styled.div`
  color: ${saasModernTheme.colors.black};

  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  flex-wrap: wrap;
`;

export const Packaging = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: ${saasModernTheme.space[8]}px 0;
`;

export const PackagingHead = styled.div`
  text-align: center;
  width: 100%;
  @media (max-width: 450px) {
    width: 100%;
  }
`;

export const Description = styled.p`
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  font-family: ${saasModernTheme.fontFamily};
  width: 70%;
  color: var(--Text-Secondary, #636f81);
  @media (max-width: 1024px) {
    font-size: 24px;
    width: 70%;
  }
  @media (max-width: 950px) {
    font-size: 24px;
    width: 60%;
  }
  @media (max-width: 600px) {
    width: 80%;
    font-size: 18px;
    line-height: 30px;
  }
`;
export const PackagingContent = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 4 columns by default */
  gap: 16px; /* Gap between grid items */
  margin-top: 64px;
  width: 100%;
  @media (max-width: 1200px) {
    grid-template-columns: repeat(1, 1fr); /* 2 columns for screens <= 450px */
  }
  @media (max-width: 950px) {
    width: 100%;
  }
  @media (max-width: 450px) {
    grid-template-columns: repeat(1, 1fr); /* 2 columns for screens <= 450px */
  }
`;

export const ButtonTryPremiumFree = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 50px auto;
  border-radius: 50px;
  padding: 12px 16px;
  color: var(--Text-Secondary, #636f81);
  font-family: ${saasModernTheme.fontFamily};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 22.4px */
  letter-spacing: -0.32px;
  text-transform: none;

  background: linear-gradient(
    90deg,
    rgba(0, 111, 255, 0.08) 9.37%,
    rgba(255, 110, 114, 0.08) 54.63%,
    rgba(255, 182, 86, 0.08) 99.89%
  );

  position: relative;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    border-radius: 50px;
    padding: 1px;
    background: linear-gradient(90deg, #006fff, #ff6e72, #ffb656);
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    z-index: -1;
  }
`;

export const Princing = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: ${saasModernTheme.space[8]}px 0 110px 0;
  text-align: center;
`;

export const PackagingPercentageContent = styled.div`
  width: 79px;
  height: 66px;
  flex-shrink: 0;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;

  font-weight: 600;
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : '#ffb800 '};
`;

export const Circle1 = styled.div`
  width: 794.352px;
  height: 1361.863px;
  transform: rotate(8.899deg);
  flex-shrink: 0;
  border-radius: 1361.863px;
  opacity: 0.2;
  background: #8593e8;
  filter: blur(100px);
  position: absolute;
  left: -40%;
  @media (max-width: 450px) {
    top: 5%;
    left: 0%;
  }
`;

export const Circle2 = styled.div`
  width: 50%;
  height: 60%;
  transform: rotate(8.899deg);
  flex-shrink: 0;
  border-radius: 1376.601px;
  opacity: 0.2;
  background: #5d6ef3;
  filter: blur(125px);
  position: absolute;
  top: 20%;
  left: 25%;
  @media (max-width: 450px) {
    top: 40%;
  }
`;

export const Circle3 = styled.div`
  width: 763.536px;
  height: 1314.699px;
  transform: rotate(8.899deg);
  flex-shrink: 0;
  border-radius: 1314.699px;
  opacity: 0.2;
  background: #fc4ff6;
  filter: blur(100px);
  position: absolute;
  right: -30%;
  top: 20%;
  @media (max-width: 450px) {
    top: 70%;
  }
`;

export const ListPlan = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
`;

export const ListPlanContent = styled.li`
  margin: ${saasModernTheme.space[3]}px 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ContentIconListPlan = styled.div`
  width: 24px;
  height: 24px;
`;
